import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database } from '@core';

import { withLimit } from './uiNodes';

export const getSwingMeasuredParameters = async (supabase: SupabaseClient<Database>) => {
    const { data, error } = await withLimit(
        3000,
        supabase.from('swing_measured_parameters').select('*, units(*)').order('id', { ascending: true }),
    );

    if (error) {
        console.error('error fetching ui_nodes:', error);
        return [];
    }

    const converted = camelcaseKeys(data, { deep: true });
    return converted;
};

export type SwingMeasuredParameter = Awaited<ReturnType<typeof getSwingMeasuredParameters>>[number];
